<h1 class="text-center text-primary">Promo</h1>
<br/>

<div class="container" >
  <form [formGroup]="promotionForm" (ngSubmit)="promotionForm.valid " autocomplete="off">
    <table class="table table-hover">
      <thead>
        <tr>
        </tr>
      </thead>
      <tbody>

        <mat-tab-group  animationDuration="0ms" mat-align-tabs="center" style="max-width: 1000px; margin: auto;" >
          @for (promotion of promotions; track promotion; let i = $index) {
            <mat-tab formArrayName="promo" label="{{promotion.promotionHeader.omschrijving}}" >
              <ng-container [formGroupName]="i">
                <br/>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Product Code</th>
                      <th scope="col">Description</th>
                      <th scope="col"></th>
                      <th scope="col" class="text-right">Core</th>
                      <th scope="col" class="text-right">Normal Price</th>
                      <th scope="col" class="text-right">Promo Price</th>
                      <th scope="col" class="text-right">Quantity</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (line of promotion.promotionLines; track line; let j = $index) {
                      <tr formArrayName="lijnen" >
                        <ng-container [formGroupName]="j">
                          <td><img src="../../../assets/{{line.merk.toLowerCase()}}.png" alt="{{line.merk}}" height="20"  > {{line.xref}}</td>
                          <td>@if (line.isDpmPrijslijst === true) {
                            <img src="../../../assets/dpm2.png" height="20" style="padding: 0px 10px 0px 0px;">
                          }{{line.omschrijving}}</td>
                          <td>@if (line.image1?.length > 0) {
                            <button class="btn btn-primary mr-3" (click)="openPicture(pictureTemplate, line.image1, line.image2, line.image3, line.xref)"><img src="../../../assets/camera.png" alt="Show image" Height="30" style="padding: 0px 0px 5px 0px;"></button>
                          }</td>
                          <td class="text-right">{{line.statiegeld.toFixed(2)}}</td>
                          <td class="text-right">{{line.brutoprijs.toFixed(2)}}</td>
                          <td class="text-right">{{line.prijs.toFixed(2)}}</td>
                          <td class="text-right"><input type="text" formControlName="qty" value="{{line.aantalBestelling}}" class="text-right" size="5"/></td>
                          <td><button
                            class="btn btn-success"
                            type="button"
                            title="Add to order"
                            (click)="addRegel(i, j)"><b>+</b></button></td>
                          </ng-container>
                        </tr>
                      }
                    </tbody>
                    <tfoot>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </tfoot>
                  </table>
                  <div class="form-group text-right">
                    <button [disabled]='!promotionForm.valid' class="btn btn-primary mr-2" (click)="onAddToBasket()">Add to order</button>
                  </div>
                </ng-container>
              </mat-tab>
            }
          </mat-tab-group>



        </tbody>
        <tfoot>
          <tr>


          </tr>
        </tfoot>
      </table>

    </form>
  </div>


  <ng-template #pictureTemplate>


    <div class="row" >
      <div class="col-11">
        <h2>Product Code {{picturePartNumber}}</h2>
      </div>
      <div class="col-1">

        <button
          class="btn btn-danger"
          type="button"
          title="Close"
          (click)="pictureDialogRef?.close()"><b>X</b></button>
        </div>
      </div>
      <div class="row justify-content-center" style="padding: 10px 10px 10px 10px;">
        <img src="{{pictureUrlActive}}" height="600" style="height:100; width:100">
      </div>
      <div class="row justify-content-center">
        <div class="col-2">
          <img src="{{pictureUrl1}}" height="60" (click)="changeActivePicture(1)" class="{{pictureStatus1}}">
        </div>
        <div class="col-2">
          <img src="{{pictureUrl2}}" height="60" (click)="changeActivePicture(2)" class="{{pictureStatus2}}" >
        </div>
        <div class="col-2">
          <img src="{{pictureUrl3}}" height="60" (click)="changeActivePicture(3)" class="{{pictureStatus3}}">
        </div>

      </div>


    </ng-template>